<template>
	<PopUp
		title="Ausschluss entfernen"
		ok-text="Löschen"
		:ok-disabled="removing"
		:ok-loading="removing"
		:closable="!removing"
		@ok="remove"
		@hidden="$emit('hidden')"
	>
		Soll der Ausschluss für <b>{{ exclusion.pseudonym.label }}</b> wirklich gelöscht werden?
	</PopUp>
</template>

<script>
import PopUp from "@/vue/common/PopUp";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import JobProfileExclusion from "@/api/customer/job-profile/applicant/Exclusion";
import CustomerExclusion from "@/api/customer/applicant/Exclusion";

export default {

	components: {
		PopUp,
	},

	props: {
		exclusion: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			removing: false,
		};
	},

	methods: {
		async remove ()
		{
			this.removing = true;

			try
			{
				if (this.exclusion.type === 'total')
				{
					await new CustomerExclusion()
						.setPseudonymId(this.exclusion.pseudonym.id)
						.remove()
						.call();
				}
				else
				{
					await new JobProfileExclusion()
						.setJobProfileId(this.exclusion.jobProfile.id)
						.setPseudonymId(this.exclusion.pseudonym.id)
						.remove()
						.call();
				}

				this.$emit('remove');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.removing = false;
		}
	}
}
</script>